<script>
  import io from 'socket.io-client';
  import _ from 'lodash';
  import { DateTime } from 'luxon';
  import { onMount } from 'svelte';

  export let socket, room;

  // const logDir = `log/${room}`; // Path to log directory from app root
  const logDir = `log/`; // Path to log directory from app root
  let logs = [];
  let logsEl = {};
  let details = {};

  // Assign a color to each unique IP for easy visualization in /logs page.
  let ipColorsMap = {};
  let nextIpColor = 0;
  let ipColors = ['green', 'yellow', 'orange', 'blue', 'purple', 'teal', 'red'];

  function mapIpToColor(ip) {
    if (!ipColorsMap[ip]) {
      ipColorsMap[ip] = ipColors[nextIpColor];
      nextIpColor += 1;
      if (nextIpColor >= ipColors.length) {
        nextIpColor = 0;
      }
    }
  }

  function scrollToBottom() {
    // Hacky but works: Wait for DOM to redraw.
    window.setTimeout(function() {
      logsEl.scrollTop = logsEl.scrollHeight;
    }, 100);
  }

  function formatTimestamp(timestamp) {
    // return log.timestamp.substring(11, log.timestamp.length - 4);
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const ts = DateTime.fromISO(timestamp);
    const tsLocal = ts.setZone(tz).toString();
    const date = tsLocal.substring(0, 10);
    const time = tsLocal.substring(11, 19);
    return date + ' ' + time;
  }

  function toggleDetails(index) {
    details[index] = details[index] ? false : true;
  }

  onMount(async () => {
    await socket;
    // Get socket connection for logs.
    socket.on('connect', () => {
      socket.emit('getLogs', logDir);

      // Populate first 100 logs on load.
      socket.on('initLogs', initLogs => {
        const ts = initLogs[0].timestamp;
        initLogs.map(log => {
          if (log.request && log.request.ip) {
            mapIpToColor(log.request.ip);
          }
        });
        logs = initLogs;
        scrollToBottom();
      });

      // Add new logs as they arrive
      socket.on('updateLogs', newLogs => {
        logs = [...logs, ...newLogs];
        scrollToBottom();
      });
    });
  });
</script>

<style lang="postcss">
  .logs::-webkit-scrollbar {
    display: none;
  }
  .logs {
    -ms-overflow-style: none; /* Hide scrollbar for Edge (fyi, can't hide in Firefox) */
  }
  .debug {
    @apply text-gray-700;
  }
  .info,
  .error {
    @apply text-gray-400;
  }
</style>

<div class="logs overflow-y-auto" bind:this="{logsEl}">
  <table class="m-4 ml-0" style="border-spacing: 0.1rem">
    {#each logs as log, index}
      <tr class="{log.request ? 'cursor-pointer' : ''}" on:click="{() => toggleDetails(index)}">
        <td
          class="w-4 opacity-50"
          style="{`background: ${ipColorsMap[log.request && log.request.ip]}`}"></td>
        <td class="px-2 text-xs text-gray-700">{formatTimestamp(log.timestamp)}</td>
        <td class="{log.level}">
          {#if log.level == 'error'}
            <span class="bg-red-600 text-white rounded py1 px2 mr2 font-bold text-sm">ERROR</span>
          {/if}
          {log.message}
          {#if log.request && log.request.ip}| {log.request.ip}{/if}
        </td>
      </tr>
      {#if details[index] && log.request}
        <tr>
          <td></td>
          <td></td>
          <td>
            {log.request.os.name} {log.request.os.version} / {log.request.browser.name}
            {log.request.browser.version}
          </td>
        </tr>
      {/if}
    {/each}
  </table>
</div>
